import { useEffect, useMemo, useState } from 'react';

import BetterLogoSvg from '../../assets/white-labelling/BetterInspect.svg';
import HomeRiverGroupLogoSvg from '../../assets/white-labelling/HomeRiverGroup.svg';
import InspectifyLogoSvg from '../../assets/inspectify/Inspectify_Logo_Color.svg';
import { useTypedSelector } from '../../redux/store';
import { selectActive, selectRehabProject, selectTeams, selectWorksOrder } from '../../redux/selectors';

type WhiteLabellingData = {
  enabled: boolean;
  displayName: string;
  logo: any;
  email: string;
  phoneNumber: string;
  phoneNumberLink: string;
  formattedPhoneNumber: string;
};

const BETTER_INSPECT_COMPANY_ID = '281';
const betterInspectWhiteLabellingData: WhiteLabellingData = {
  enabled: true,
  displayName: 'Better Inspect',
  logo: BetterLogoSvg,
  email: 'betterinspect@inspectify.com',
  phoneNumber: '8552716922',
  phoneNumberLink: 'tel:855-271-6922',
  formattedPhoneNumber: '1 (855) 271-6922',
};

const HRG_COMPANY_ID = '1575';
const hrgWhiteLabellingData: WhiteLabellingData = {
  enabled: true,
  displayName: 'Home River Group',
  logo: HomeRiverGroupLogoSvg,
  email: 'fieldreports@homeriver.com',
  phoneNumber: '8884481748',
  phoneNumberLink: 'tel:888-448-1748',
  formattedPhoneNumber: '1 (888) 448-1748',
};

const whiteLabellingMap: {[companyId: string]: WhiteLabellingData} = {
  [BETTER_INSPECT_COMPANY_ID]: betterInspectWhiteLabellingData,
  [HRG_COMPANY_ID]: hrgWhiteLabellingData,
};

export const useWhiteLabelling = () => {
  const active = useTypedSelector(selectActive);
  const order = useTypedSelector((state) => selectWorksOrder(state, active.order.id));
  const project = useTypedSelector((state) => selectRehabProject(state, active.project.id));
  const teams = useTypedSelector(selectTeams);

  const [whiteLabellingData, setWhiteLabellingData] = useState<WhiteLabellingData>({
    enabled: false,
    displayName: 'Inspectify',
    logo: InspectifyLogoSvg,
    email: 'hello@inspectify.com',
    phoneNumber: '8552716876',
    phoneNumberLink: 'tel:855-271-6876',
    formattedPhoneNumber: '1 (855) 271-6876',
  });

  const companyId = useMemo(() => {
    if (order) {
      return order.team.companyId;
    }

    if (project) {
      return Object.values(teams).find((team) => team.id === project.teamId)?.companyId;
    }

    return null;
  }, [order, project, teams]);

  useEffect(() => {
    if (!companyId) return;

    if (whiteLabellingMap[companyId]) {
      setWhiteLabellingData(whiteLabellingMap[companyId]);
    }
  }, [order, setWhiteLabellingData]);

  return whiteLabellingData;
};
